import { render, staticRenderFns } from "./tenant-switch.vue?vue&type=template&id=1651da08&"
import script from "./tenant-switch.vue?vue&type=script&lang=ts&"
export * from "./tenant-switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenant-switch.vue"
export default component.exports